///////////////////////////////////
//
// Action types
//
///////////////////////////////////

export const dashboardAction = {
  OPEN_INCIDENTS: "OPEN_INCIDENTS",
  HIGH_PRIORITY_INCIDENTS: "HIGH_PRIORITY_INCIDENTS",
  TOP_INCIDENTS: "TOP_INCIDENTS",
};

export const alertConstants = {
  SUCCESS: "ALERT_SUCCESS",
  ERROR: "ALERT_ERROR",
  CLEAR: "ALERT_CLEAR",
};

export const authAction = {
  LOGIN_USER: "LOGIN_USER",
  LOGOUT_USER: "LOGOUT_USER",
  LOGIN_LOADING: "LOGIN_LOADING",
};

export const fisApiAction = {
  EMPDETAILS: "EMPDETAILS",
  EMPNOTFOUND: "EMPNOTFOUND",
};

export const incidentAction = {
  ROLEAUTHORIZATION: "ROLEAUTHORIZATION",
  FETCH_PICKLISTS: "FETCH_PICKLISTS",

  RESET_SELECTED_INCIDENT: "RESET_SELECTED_INCIDENT",
};
export const busIncidentAction = {
  FETCH_BUS_INCIDENT_BY_RECORDID: "FETCH_BUS_INCIDENT_BY_RECORDID",
  FETCHBUSINCIDENTS: "FETCHBUSINCIDENTS",
};
export const railIncidentAction = {
  FETCH_RAIL_INCIDENT_BY_RECORDID: "FETCH_RAIL_INCIDENT_BY_RECORDID",
  FETCHRAILINCIDENTS: "FETCHRAILINCIDENTS",
};
export const investigationAction = {
  FETCH_INVESTIGATION_BY_INVESTIGATIONID:
    "FETCH_INVESTIGATION_BY_INVESTIGATIONID",
  INVESTIGATION_ADD_NEW: "INVESTIGATION_ADD_NEW",
  FETCH_INVESTIGATIONS: "FETCH_INVESTIGATIONS",
  DELETE_INVESTIGATION: "DELETE_INVESTIGATION",
};

export const reportsAction = {
  FETCH_ALL_REPORTS: "FETCH_ALL_REPORTS",
  FETCH_ADA_REPORTS: "FETCH_ADA_REPORTS",
  FETCH_REPORT_PARAMS: "FETCH_REPORT_PARAMS",
};

export const administrationAction = {
  FETCH_USERS: "FETCH_USERS",
  FETCH_USER_DETAIL: "FETCH_USER_DETAIL",
  FETCH_ROLES: "FETCH_ROLES",
};

export const auditAction = {
  FECTCH_AUDITS: "FECTCH_AUDITS",
};

export const picklistAction = {
  FETCH_PICKLISTS: "FETCH_PICKLISTS",
  FETCH_PICKLISTS_LIMIT: "FETCH_PICKLISTS_LIMIT",
  FETCH_PICKLISTS_BY_CODE: "FETCH_PICKLISTS_BY_CODE",
  FETCH_PICKLIST_CODES: "FETCH_PICKLIST_CODES",
};

export const operatorAssignmentAction = {
  FETCH_OPERATORS: "FETCH_OPERATORS",
  GET_OPERATOR_DETAIL: "GET_OPERATOR_DETAIL",
};
export const EmailGroupAction = {
  FETCH_ALL_EMAIL_GROUPS: "FETCH_ALL_EMAIL_GROUPS",
  FETCH_EMAIL_GROUPS: "FETCH_EMAIL_GROUPS",
  FETCH_EMMAIL_GROUP_DETAIL: "FETCH_EMMAIL_GROUP_DETAIL",
};
